module.exports = __webpack_public_path__ + "img/76145.f863f077.svg";